/* eslint-disable-next-line no-restricted-imports */
import * as t from 'io-ts';

export const tCloudflareHostnameV2 = t.type({
  id: t.union([t.number, t.null]),
  hostname: t.union([t.string, t.null]),
});
